
export const text = `
???
`